/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect } from 'react';
import wavesImg from 'assets/images/waves.svg';
import advisory from 'assets/images/icon-cadastral-advisory-001.svg';
import advisory2 from 'assets/images/icon-cadastral-advisory-002.svg';
import createTrack from 'services/actions/tracker_actions';
import { openSupportChat } from 'services/support_chat';
import { Container } from './styles';

const CadastralAdvisory = () => {
  useEffect(() => {
    createTrack('Acessou Assessoria Cadastral', {});
    document.title = 'Assessoria Cadastral - ConLicitação';
  }, []);

  return (
    <Container>
      <div className="container p-4 mt-5">
        <div className="row">
          <div className="col-12">
            <div className={`card card-shadow p-1 p-md-4 `}>
              <div className="active-services-bg">
                <div className="row align-items-center m-0">
                  <div className="col-12 col-md-6">
                    <h4 className="mb-0 px-md-3 px-4 py-md-0 py-5">
                      Melhore sua experiência com o ConLicitação através dos nossos novos serviços
                    </h4>
                  </div>
                  <div className="col-12 col-md-6 p-0">
                    <div className="active-services-wave">
                      <img className="active-services-wave-img d-none d-lg-block" src={wavesImg} />
                      <div className="active-services-wave-bg">
                        <h4 className="text-white mb-0">
                          Uma equipe especializada para realizar o credenciamento da sua empresa
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row align-items-center px-md-0 px-3">
                <div className="col-12 col-md-6  mt-5 mt-md-0">
                  <h4 className="text-center mb-3 font-weight-bold">Assessoria Cadastral</h4>
                  <p>
                    {' '}
                    Se você encontrou alguma dificuldade para fazer o cadastro da sua empresa nos
                    CRCs unificados e PORTAIS de compras públicas, estamos aqui para te ajudar.{' '}
                  </p>
                  <p>
                    {' '}
                    Apesar do cadastramento nos órgãos ser inteiramente gratuito, fazê-lo sozinho
                    pode ser um desafio, principalmente para quem não tem tanta familiaridade com a
                    documentação exigida.{' '}
                  </p>
                  <h4 className="text-center mb-3 mt-5 font-weight-bold">CRCs que Atuamos</h4>
                  <ul className="list-portais px-3">
                    <li> Governo Federal e Distrito Federal - SICAF DIGITAL/COMPRASNET; </li>
                    <li> São Paulo - CAUFESP/BEC; </li>
                    <li> Minas Gerais - CAGEF; </li>
                    <li> Rio de Janeiro e Espírito Santo - SIGA; </li>
                    <li> Bahia - CAF; </li>
                    <li>Paraíba - CECH; </li>
                    <li>Santa Catarina - CCF DIGITAL; </li>
                    <li>Mato Grosso - CGF; </li>
                    <li>Piauí - CADUF; </li>
                    <li>Mato Grosso do Sul, Tocantins, Maranhão e Amapá - E-FORNECEDOR;</li>
                    <li>
                      Paraná, Rio Grande do Sul, Rio Grande do Norte, Acre, Rondônia, Pará -
                      CADASTRO DE FORNECEDOR;{' '}
                    </li>
                    <li>Pernambuco e Goiás - CADFOR; </li>
                    <li>Amazonas, Sergipe, Ceará, Roraima e Alagoas - CRC;</li>
                    <li>Empresas públicas e de economia mista - PETRONECT. </li>
                  </ul>
                </div>
                <div className="col-12 col-md-6 p-3">
                  <div className="row mb-4">
                    <div className="col-md-6 mb-md-0 mb-3">
                      <div className="card background-card p-3 text-center justify-content-center align-items-center">
                        <p className="font-weight-bold"> Credenciamento </p>
                        <img className="mb-3" src={advisory} alt="chat" />
                        <p className="text-card-icon">
                          {' '}
                          Cadastro no CRC e PORTAL incluindo a validação de toda a documentação
                          necessária.{' '}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card background-card p-3 text-center justify-content-center align-items-center">
                        <p className="font-weight-bold">Gestão do CRC</p>
                        <img className="mb-3" src={advisory2} alt="chat" />
                        <p className="text-card-icon">
                          Acompanhamento e atualização periódica da documentação no CRC.
                        </p>
                      </div>
                    </div>
                  </div>
                  <h4 className="text-center mb-3 font-weight-bold">Benefícios</h4>
                  <ul className="list-with-check mt-2 mb-4">
                    <li>
                      <span className="oi oi-check pr-2" />
                      Economia de tempo: Foque no seu produto e serviço, enquanto nós cuidamos de
                      toda a papelada;
                    </li>
                    <li>
                      <span className="oi oi-check pr-2" />
                      Segurança e garantia: A tranquilidade de saber que todas as suas documentações
                      foram corretamente cadastradas;
                    </li>
                    <li>
                      <span className="oi oi-check pr-2" />
                      Redução de riscos: De fracassar no credenciamento ou na fase de habilitação;
                    </li>
                    <li>
                      <span className="oi oi-check pr-2" />
                      Agilidade de aprovação: Seu cadastro será analisado e ativado muito mais
                      rápido;
                    </li>
                  </ul>
                  <button
                    type="button"
                    className="mt-3 btn btn-primary btn-lg btn-block"
                    onClick={() => {
                      openSupportChat();
                    }}
                  >
                    Clique e fale com um consultor pelo chat
                  </button>
                  <p className="mt-2">
                    {' '}
                    Se preferir entre em contato conosco pelo telefone e whatsapp +55 (11) 3789-9102
                    ou pelo e-mail{' '}
                    <a href="mailto:comercial@conlicitacao.com.br">
                      comercial@conlicitacao.com.br
                    </a>{' '}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CadastralAdvisory;
